<template>
  <v-item-group
    v-model="selectedAnalysisTypes"
    @change="onChange"
    :multiple="chargeTypeIsCredits"
    class="flex-fill"
  >
    <v-row
      class="ma-0"
    >
      <v-item
        v-slot:default="{ active, toggle }"
        v-for="type in availableAnalysisTypes"
        :key="type['ab_analysis_type']"
        :value="type"
      >
        <v-col
          cols="4"
          class="px-0 text-center"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click="toggle"
                fab
                small
                :color="active ? 'success' : ''"
                elevation="2"
                v-if="chargeTypeIsCredits"
              >
                <component
                  :is="displayAnalysisTypeIcon(type['ab_analysis_type'])"
                  :class="['svg-icon', {
                  'active': active
                  }]"
                >
                </component>
              </v-btn>
              <v-btn
                v-on="on"
                @click="toggle"
                fab
                small
                :color="analysysSelect == type['ab_analysis_type'] ? 'success' : ''"
                elevation="2"
                v-else
              >
                <component
                  :is="displayAnalysisTypeIcon(type['ab_analysis_type'])"
                  :class="['svg-icon', {
                  'active': active
                  }]"
                >
                </component>
              </v-btn>              
              
            </template>
            <span>{{type["nm_analysis_type"]}}</span>
          </v-tooltip>
        </v-col>
      </v-item>
    </v-row>
  </v-item-group>
</template>

<script>

import {ANALYSIS_TYPES_ICONS} from "../../../../helpers/post-processings/constants"
import {isEqual} from "lodash/lang"
import {find, forEach, some} from "lodash/collection"
import {getAfterProcessingItens} from "@/api/api-billing";

export default {
    name: "AnalysisTypes",
    model: {
      prop: "model",
      event: "change"
    },
    props: {
      model: {
        type: Array,
        required: true,
      },
      postProcessingPrices: {
        type: Object,
        required: true,
      },
      flPriceMultiplier: {
        type: Number,
        required: true
      },
      abCropType: {
        type: String,
        validator: prop => typeof prop === "string" || prop === null || prop === undefined,
      }
    },
    data: () => ({
      selectedAnalysisTypes: [],
    }),
    methods: {
      onChange(value) {
        if (this.chargeTypeIsCredits) {
          this.$emit("change", this.selectedAnalysisTypes)
          let flPriceMultiplier = 0.0
          forEach(value, analysisType => {
            const item = find(this.postProcessingPrices.all, priceItem => {
              return isEqual(priceItem["agronomic_analyzes"]["ab_analysis_type"], analysisType["ab_analysis_type"]) &&
                isEqual(priceItem["crop_type"]["ab_crop_type"], this.abCropType)
            })
            if (item)
              flPriceMultiplier += this.$appMng.isIntl ? item["price_product"]["fl_intl_base_price"] : item["price_product"]["fl_base_price"]
          })
          this.$emit("update:flPriceMultiplier", flPriceMultiplier)
        } else {
          this.selectedAnalysisTypes = new Array(value)
          this.$emit("change", this.selectedAnalysisTypes)
          this.$emit("update:flPriceMultiplier", 0.1) 
        }

      },
      displayAnalysisTypeIcon(value) {
        const iconName = ANALYSIS_TYPES_ICONS[value]
        const SVGIcon = require(`../../../../assets/map/${iconName}.svg?inline`)
        return SVGIcon.default
      },
      retrievePlanType() {
        let dataProcessing = {
          "str_crop_type": this.abCropType,
          "str_analysis_type": this.selectedAnalysisTypes[0].ab_analysis_type
        }
        getAfterProcessingItens(this.$apiAuth.getAuthToken(), dataProcessing)
        .then((res) => {
          const data = res.data.data
          this.$emit('changePlanType',data.cd_hectare_package)
          })
      }
    },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },
      analysysSelect() {
        if(this.selectedAnalysisTypes.length == 0) return ''
        this.retrievePlanType()
        return this.selectedAnalysisTypes[0].ab_analysis_type
      },
      availableAnalysisTypes() {
        const availableAnalysisTypes = []
        if (!this.abCropType) return []
        forEach(this.postProcessingPrices.all, item => {
          if (isEqual(item["crop_type"]["ab_crop_type"], this.abCropType))
            if (!some(availableAnalysisTypes, item["agronomic_analyzes"]))
              availableAnalysisTypes.push(item["agronomic_analyzes"])
        })
        return availableAnalysisTypes
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~vuetify/src/styles/settings/colors";

  .svg-icon {
    font-size: 24px;
    width: 24px;
    height: 24px;

    &.active {
      fill: #FFFFFF;
      stroke: #FFFFFF;
    }

    &:not(.active) {
      fill: #{map-deep-get($grey, "darken-1")};
      stroke: #{map-deep-get($grey, "darken-1")};
    }
  }

</style>
